import $api from "../http";

export default class InstructionService {
  static async getAll() {
    return (await $api.get("/api/instructions")).data;
  }
}
